<div class="modal-backdrop" (click)="closeModal()"></div>

<div class="modal-card">

  <button class="close-btn" (click)="closeModal()">
    <i class="bi bi-close"></i>
  </button>

  <ng-container *ngIf="course !== undefined && course as c; else loadingTpl">

    <!-- Header -->
    <div class="header-row">
      <div class="header-left">
        <h2 class="title">{{ c.title }}</h2>
        <p class="subtitle">Users enrolled in this course</p>
      </div>

      <div class="total">
        <p class="meta-label">Total Enrollments</p>
        <p class="total-count">{{ c.totalEnrollments | number }}</p>
      </div>
    </div>

    <!-- Users List -->
    <div class="user-list">

      <div class="user-header-row">
        <span>User</span>
        <span>Enrolled Date</span>
        <span>Progress</span>
      </div>

      <!-- If users exist -->
      <ng-container *ngIf="c.users?.length; else noEnrollments">

        <div class="user-row" *ngFor="let u of c.users">

          <div class="user-info">
            <div class="avatar">{{ u.initials }}</div>

            <div class="user-text">
              <p class="name" [title]="u.name">
                {{ u.name | slice:0:14 }}{{ u.name.length > 14 ? '...' : '' }}
              </p>

              <p class="email" [title]="u.email">
                {{ u.email | slice:0:14 }}{{ u.email.length > 14 ? '...' : '' }}
              </p>
            </div>
          </div>

          <p class="date">{{ u.enrolledDate }}</p>

          <div class="progress-group">
            <div class="progress-bar">
              <span [style.width.%]="u.progress"></span>
            </div>
            <span class="progress-text">{{ u.progress }}%</span>
          </div>

        </div>

      </ng-container>
    
      <!-- Empty State -->
      <ng-template #noEnrollments>
        <div class="no-data">
          <span class="material-icons">group_off</span>
          <p>No users enrolled yet</p>
        </div>
      </ng-template>

    </div>

  </ng-container>

  <!-- Loading State -->
  <ng-template #loadingTpl>
    <p class="loading-text">Loading enrolled users...</p>
  </ng-template>


  <div class="pagination">
  <button
    (click)="changePage(currentPage - 1)"
    [disabled]="currentPage === 1">
    Prev
  </button>

  <span>
    {{currentPage}} / {{totalPages}}
  </span>

  <button
    (click)="changePage(currentPage + 1)"
    [disabled]="currentPage === totalPages">
    Next
  </button>
</div>

  <!-- Footer -->
  <div class="footer">
    <button class="btn-outline" (click)="closeModal()">Close</button>
  </div>

</div>
